import { jsxs as c, jsx as l, Fragment as y } from "react/jsx-runtime";
import b from "react";
import { _ as x, f as C, e as I } from "../chunks/vendor_rango__tokens.38ee67b0.js";
import i, { css as o } from "styled-components";
import { R as S } from "../chunks/index.cff5baaf.js";
const a = {
  SM: "sm",
  MD: "md",
  LG: "lg"
};
Object.values(a);
const r = {
  Default: "default",
  Income: "income",
  Outcome: "outcome",
  Sale: "sale"
};
Object.values(r);
const n = i(S).withConfig({
  displayName: "Icon",
  componentId: "sc-1pfs51h-0"
})([""]), w = i.div.withConfig({
  displayName: "Currency",
  componentId: "sc-1pfs51h-1"
})(["display:inline-flex;align-items:center;& ", "{display:flex;margin-right:var(--spacing-half);}", " ", " ", " ", " ", " ", " ", " ", ""], n, (e) => (e.type === r.Default || e.type === r.Sale) && o(["color:var(--text-label-color);"]), (e) => e.type === r.Income && o(["color:var(--positive-label-color);& ", "{color:var(--positive-icon-color);}"], n), (e) => e.type === r.Outcome && o(["color:var(--negative-label-color);& ", "{color:var(--negative-icon-color);}"], n), (e) => e.type === r.Sale && o(["display:inline-flex;flex-direction:column-reverse;align-items:flex-start;"]), (e) => e.size === a.SM && o(["", ""], x), (e) => e.size === a.MD && o(["", ""], C), (e) => e.size === a.LG && o(["font-family:var(--font-family-base);font-weight:var(--font-weight-regular);font-size:var(--font-size-lg);line-height:var(--line-height-default);"]), (e) => e.size === a.LG && e.type === r.Default && o(["color:var(--text-label-highlight-color);"])), z = i.span.withConfig({
  displayName: "HiddenPrice",
  componentId: "sc-1pfs51h-2"
})(["display:flex;align-items:center;"]), D = i.span.withConfig({
  displayName: "Dot",
  componentId: "sc-1pfs51h-3"
})(["display:inline-block;margin-left:var(--spacing-half);border-radius:var(--border-radius-circular);background-color:currentColor;width:var(--size-half);height:var(--size-half);", ""], (e) => e.size === a.LG && o(["width:var(--size-1x);height:var(--size-1x);"])), L = i.span.withConfig({
  displayName: "Sale",
  componentId: "sc-1pfs51h-4"
})(["", " color:var(--negative-label-color);margin-bottom:var(--spacing-half);text-decoration:line-through;"], I), R = b.forwardRef(({
  type: e = r.Default,
  size: t = a.SM,
  hidden: s = !1,
  price: d = "",
  sale: f = "",
  ...m
}, p) => {
  const g = () => {
    if (e === r.Sale)
      return /* @__PURE__ */ l(L, { children: f });
  }, h = () => {
    if (e === r.Income)
      return /* @__PURE__ */ l(n, { icon: "UpLine", size: t.toUpperCase() });
    if (e === r.Outcome)
      return /* @__PURE__ */ l(n, { icon: "DownLine", size: t.toLocaleUpperCase() });
  }, u = () => s ? /* @__PURE__ */ c(z, { children: [
    "R$",
    [...Array(4)].map((v) => /* @__PURE__ */ l(D, { size: t }, v))
  ] }) : /* @__PURE__ */ c(y, { children: [
    d,
    g()
  ] });
  return /* @__PURE__ */ c(w, { type: e, size: t, ...m, ref: p, "data-testid": "rango-currency", "data-rango-component": "rango-currency", "data-is-rango": !0, children: [
    h(),
    u()
  ] });
});
R.displayName = "RangoCurrency";
export {
  a as CurrencySize,
  r as CurrencyType,
  R as RangoCurrency
};
